import SideBarOptions from "base/src/utils/SideBarOptions";

export const sideBarOptions: Array<SideBarOptions> = [
  {
    Title: 'Campanha',
    LinkTo: '/',
    Icon: 'ic:baseline-apps'
  }
]